(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Plans.CollegePlan",
                    {
                        url: "/CollegePlan/{collegePlanId}",
                        component: "collegeplanNew",
                        PageTitle: "College Plan | Marketing Tracker",
                        resolve: {
                            collegePlanDocument: ["$stateParams", "marketingPlanApi", "marketingTrackerAgent",
                                function ($stateParams, marketingPlanApi, marketingTrackerAgent) {
                                    return marketingPlanApi
                                        .getCollegePlanDocument(marketingTrackerAgent.AgentId, $stateParams.collegePlanId)
                                        .then(function (file) {
                                            return URL.createObjectURL(file);
                                        });
                                }]
                        }
                    });
        }
    ]);

    app.component("collegeplanNew",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Plans/CollegePlan/collegeplan-new-template.html",
            controller: collegePlanNewController,
            bindings: {
                collegePlanDocument: "<"
            }
        });

    collegePlanNewController.$inject = ["$scope"];
    function collegePlanNewController($scope) {
        var $ctrl = this;

        $scope.$on("$destroy",
            function () {
                if ($ctrl.collegePlanDocument)
                    URL.revokeObjectURL($ctrl.collegePlanDocument);
            });
    }

})(window.app);